var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 629,
    viewBox: "0 0 1440 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_544_2895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M812.545 339.992C1074.77 388.674 1471.92 393.337 1471.92 393.337L1471.92 260.099L812.545 339.992Z",
    fill: "url(#paint0_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1471.92 628.602L-49.3667 628.602L-49.3667 91.7324L1471.92 91.7323L1471.92 628.602Z",
    fill: "url(#paint1_radial_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.92 628.602L-49.3667 628.602L-49.3667 91.7324L1471.92 91.7323L1471.92 628.602Z",
    fill: "url(#paint2_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0317 374.187C276.753 361.814 499.821 440.34 792.727 446.992C1085.63 453.645 1367.28 379.596 1472.63 379.596L1472.63 297.651L70.8075 313.692L29.0317 374.187Z",
    fill: "url(#paint3_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.693 327.122C456.856 325.132 113.217 421.75 -49.3673 421.75L-49.3673 257.487L700.693 327.122Z",
    fill: "url(#paint4_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.3667 318.169L-49.3667 91.7329L1471.92 91.7328L1471.92 340.365C1292.85 318.667 1120.75 361.939 812.941 378.726C597.642 390.477 406.995 360.447 210.324 338.376C209.453 338.251 208.66 338.189 207.788 338.065C179.013 334.832 150.079 331.785 120.986 329.05C115.437 328.552 109.968 328.055 104.419 327.557C99.6625 327.122 94.8269 326.687 90.0707 326.314C86.345 326.003 82.5399 325.692 78.8142 325.381C36.7213 322.024 -5.92627 319.413 -49.3667 318.169Z",
    fill: "url(#paint5_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.536 91.732C545.957 108.83 860.741 171.625 1137.24 171.625C1237.83 171.625 1366.96 132.953 1472.63 136.87L1472.63 91.7319L152.536 91.732Z",
    fill: "url(#paint6_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M152.536 91.732C545.957 108.83 860.741 171.625 1137.24 171.625C1237.83 171.625 1366.96 132.953 1472.63 136.87L1472.63 91.7319L152.536 91.732Z",
    fill: "url(#paint7_radial_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.63 91.7324L-49.3672 91.7326L-49.3672 0.64818L1472.63 0.648048L1472.63 91.7324Z",
    fill: "#D1E3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.63 131.71L-49.3672 131.71L-49.3672 91.7946L1472.63 91.7945L1472.63 131.71Z",
    fill: "url(#paint8_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_544_2895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824.697 346.435C1084.59 408.261 1478.21 414.183 1478.21 414.183L1478.21 244.97L824.697 346.435Z",
    fill: "url(#paint9_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.46 611.764L-29.5449 611.764L-29.545 16.4953L1478.46 16.4952L1478.46 611.764Z",
    fill: "url(#paint10_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1561 389.863C293.673 374.149 514.756 473.877 805.056 482.325C1095.36 490.774 1374.5 396.732 1478.91 396.732L1478.91 292.662L89.56 313.034L48.1561 389.863Z",
    fill: "url(#paint11_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.455 387.307C505.659 384.608 142.347 515.689 -29.5449 515.689L-29.5449 292.834L763.455 387.307Z",
    fill: "url(#paint12_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.5452 318.719L-29.5452 31.1447L1478.21 31.1446L1478.21 346.908C1300.73 319.35 1130.16 374.307 825.09 395.626C611.706 410.55 422.756 372.412 227.835 344.381C226.971 344.223 226.186 344.144 225.321 343.986C196.802 339.88 168.126 336.011 139.292 332.537C133.792 331.905 128.372 331.274 122.872 330.642C118.158 330.089 113.366 329.536 108.652 329.063C104.959 328.668 101.188 328.273 97.4952 327.878C55.777 323.614 13.5087 320.298 -29.5452 318.719Z",
    fill: "url(#paint13_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.561 31.1452C560.482 52.8593 872.465 132.609 1146.5 132.609C1246.2 132.609 1374.18 83.4959 1478.91 88.4704L1478.91 31.1451L170.561 31.1452Z",
    fill: "url(#paint14_linear_544_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M170.561 31.1452C560.482 52.8593 872.465 132.609 1146.5 132.609C1246.2 132.609 1374.18 83.4959 1478.91 88.4704L1478.91 31.1451L170.561 31.1452Z",
    fill: "url(#paint15_radial_544_2895)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1478.91 31.1445L-29.5452 31.1447L-29.5452 -84.5325L1478.91 -84.5326L1478.91 31.1445Z",
    fill: "#F4F9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_544_2895",
    x1: 1203.67,
    y1: 412.474,
    x2: 1090.58,
    y2: 76.0405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_544_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(991.683 483.309) rotate(180) scale(1226.76 697.574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_544_2895",
    x1: 730.218,
    y1: 314.668,
    x2: 633.721,
    y2: 691.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_544_2895",
    x1: 773.348,
    y1: 453.304,
    x2: 729.715,
    y2: 83.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_544_2895",
    x1: 335.764,
    y1: 425.055,
    x2: 304.102,
    y2: 167.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_544_2895",
    x1: 907.594,
    y1: 553.096,
    x2: 691.141,
    y2: -70.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_544_2895",
    x1: 944.247,
    y1: 463.997,
    x2: 847.437,
    y2: 19.0346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_544_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1186.09 162.852) rotate(173.695) scale(247.816 61.6256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_544_2895",
    x1: 711.633,
    y1: 93.9153,
    x2: 711.633,
    y2: 129.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_544_2895",
    x1: 1212.34,
    y1: 438.487,
    x2: 1039.56,
    y2: 37.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_544_2895",
    x1: 1049.1,
    y1: 96.3304,
    x2: 1050.92,
    y2: 519.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_544_2895",
    x1: 785.847,
    y1: 490.34,
    x2: 715.464,
    y2: 24.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_544_2895",
    x1: 377.632,
    y1: 520.176,
    x2: 323.036,
    y2: 173.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_544_2895",
    x1: 918.897,
    y1: 617.079,
    x2: 589.369,
    y2: -124.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_544_2895",
    x1: 955.226,
    y1: 503.921,
    x2: 802.121,
    y2: -45.2483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_544_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1192.53 104.435) rotate(171.94) scale(246.563 76.8037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_2895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1522,
    height: 627.954,
    fill: "white",
    transform: "translate(1472.63 628.602) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_544_2895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1508.46,
    height: 797.501,
    fill: "white",
    transform: "translate(1478.91 712.969) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg-1.9d8f95718c9642834bfdf3b28fbeeeb4.svg";
export { ForwardRef as ReactComponent };